import React, { Children, createContext, useEffect, useState } from "react";

export const ProfileVisible = createContext();

const ProfileContext = ({ children }) => {
  // const user = localStorage.getItem("userinfo")
  //   ? JSON.parse(localStorage.getItem("userinfo"))
  //   : {};
  const [visiblity, setVisiblity] = useState(null);

  const updateVisibility = (newValue) => {
    setVisiblity(newValue);
    const userData = JSON.parse(localStorage.getItem("userinfo") || "{}");
    userData.profile_visibility = newValue;
    localStorage.setItem("userinfo", JSON.stringify(userData));
  };

  useEffect(() => {
    const updateVisibilityFromStorage = () => {
      const user = JSON.parse(localStorage.getItem("userinfo") || "{}");
      setVisiblity(!!user?.profile_visibility);
    };

    updateVisibilityFromStorage();

    window.addEventListener('storage', updateVisibilityFromStorage);

    return () => {
      window.removeEventListener('storage', updateVisibilityFromStorage);
    };
  }, []);

  return (
    <>
      <ProfileVisible.Provider value={{ visiblity, setVisiblity, updateVisibility }}>
        {children}
      </ProfileVisible.Provider>
    </>
  );
};

export default ProfileContext;
